import {hot} from 'react-hot-loader/root';
import React, {useCallback, useEffect, useRef, useState} from 'react';
import {Redirect, Route, BrowserRouter, Switch} from 'react-router-dom';
import {Provider, connect} from 'react-redux';
import {bindActionCreators, Store, Dispatch} from 'redux';
import RootRoute from './router';
import {getActiveUserRole, getConfigTask, getCurrentUserMenuTree} from '@api';
import {userContext} from '@context';
import {Alert, Spin} from 'antd';
import {SAGA_GET_QA_DICT_TYPE_GROUP} from '@store/types';
import Error from '@components/error';
import { GDUSERID,GTRS_GDUSERID} from '@const';
import { UserInfoOutDate } from '@gaodun.com/gui-pc';
import { user, cookie, watermark } from '@gaodun.com/gtools';
import { IStaticConfig } from '@types';
import {setCallPlatformStatus, setWarningMessage} from '@store/actions/gdcall';
import { EnumCallInitStatus } from 'types/gdcall';
import { sensorsInit } from 'sensors-data';
import { toLogin } from '@utils';


const mapStateToProps = (state: any) => {
    return {
        callInstance: state.gdCallReduxState.get('callInstance'),
        callingStatus: state.gdCallReduxState.get('callingStatus'),
        callSystemStatus: state.gdCallReduxState.get('callSystemStatus'),
        callInitStatus: state.gdCallReduxState.get('callInitStatus'),
        callPlatformStatus:state.gdCallReduxState.get('callPlatformStatus'),
        callWarningInfo:state.gdCallReduxState.get('callWarningInfo'),
    };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        ...bindActionCreators({
            setCallPlatformStatus,
            setWarningMessage
        }, dispatch),
    };
};

interface IAppProps extends ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps>{
	store: Store
}

const App: React.FC<IAppProps> = (props: IAppProps) => {

    const REFRESH_TIMER = useRef<any>(null);
    const [appEntry, setAppEntry] = useState<boolean>(false);
    const [appEntryError, setAppEntryError] = useState<boolean>(false);
    const [userRole, setUserRole] = useState<any>(null);
    const [showModal, setShowModal] = useState<boolean>(false);
    const path = useRef<string>(location.pathname);
    const wmRef = useRef<any>();

    const createWatermark = (name?: string, userId?: number) => {
        if (wmRef.current) {
            wmRef.current.destory();
            wmRef.current = null;
        }
        const bodyEle = document.querySelector('body');
        if (bodyEle) {
            wmRef.current = new watermark({
                target: bodyEle,
                text: `${name ? name : ''} ${userId ? userId: ''}`
            });
        }
    };

    const $reqActiveUserRole = useCallback(() => {
        getActiveUserRole().then( async (res) => {
            const status = `${res.data?.status}`;
            if (res.data && +status === 0) {
                let data = res.data.result || {};
                let userRoles;
                let configRes = await getConfigTask('gtrs_config_is_open');//true 代表可以 放开菜单，
                let cres:IStaticConfig|undefined = undefined;
                if (configRes.data.result){
                    cres = JSON.parse(configRes.data.result || '{}');
                }
                switch (status) {
                case '0':
                    //请求成功,保存用户的id~用于校验用户是不是同一个人
                    sessionStorage.setItem(GDUSERID, data?.vigoUserId || -1);
                    cookie.setCookie(GDUSERID, data?.vigoUserId || -1);
                    cookie.setCookie(GTRS_GDUSERID, data?.userId || -1);
                    userRoles = {
                        isSuperAdmin: Boolean(data.superAdmin),
                        hasPermissionWithoutSA: Boolean(data.isEnable),
                        // roles: data.roles || [],// 0-一线学术老师 1-管理者
                        // hasPermissionWithoutSA: true,
                        roles: [0,1],
                        userId: data.userId,
                        avatar: data.avatar,
                        name: data.name,
                        // modes: data.modes || [],
                        modes: [0,1,2],
                        categories: data.categories || [],
                        vigoUserId: data.vigoUserId,
                        staticConfig: cres || {isOpen:true}
                    };
                    setUserRole(userRoles);
                    setAppEntry(true);
                    if (!window.__POWERED_BY_QIANKUN__) {
                        createWatermark(data.name, data.userId);
                    }
                    break;
                case 'need-login':
                    break;
                default:
                    break;
                }
            } else {
                setAppEntryError(true);
            }
        }).catch(() => {
            setAppEntryError(true);
        });
    }, []);

    const $reqAppEntryModuleData = useCallback(async () => {
        if (location.href.indexOf('player?') == -1 || location.href.includes('moredata')) {
            await $reqActiveUserRole();
            props.store.dispatch({
                type: SAGA_GET_QA_DICT_TYPE_GROUP
            });
        } else {
            const userRoles = {
                isSuperAdmin: false,
                hasPermissionWithoutSA: false,
                roles: [],// 0-一线学术老师 1-管理者
                userId: 0,
                avatar: '',
                name: '',
                modes:  [0,1,2],//添加默认 modes 配置
                categories: [],
                vigoUserId: 0,
            };
            setUserRole(userRoles);
            setAppEntry(true);
        }
    }, []);

    const updateInnfo = async () => {
        // 清除用户相关的各种缓存
        await $reqActiveUserRole();
        location.href = '/';
    };

    const setUserConfg = () => {
        user.setConfig({
            isEmpty: () => {
                $reqActiveUserRole();
            },
            isSameUser: () => {
            },
            isDifferentUser: () => {
                setShowModal(true);
            },
            // @ts-ignore 当切换回到当前tab页，并且焦点要在页面上，使用的是电话客户端的时候会触发
            useClient:() => {
                const callInstance = (window as any).gtrs_call_instance;//话务实例
                const gtrsCurrentCallPlatform = callInstance?.useBrowser;
                // const gtrsCurrentCallPlatform = (window as any).gtrs_current_call_platform;//当前页面的桌面端/浏览器 true浏览器
                if (!callInstance || !(typeof callInstance.switchPlatform === 'function') || !gtrsCurrentCallPlatform){
                    return;
                }

                callInstance.switchPlatform(false);//切换话务桌面端/浏览器
                props.setCallPlatformStatus('0');//切换UI组件桌面端/浏览器
                // (window as any).gtrs_current_call_platform = false;

            }
		  });
    };

    const gerUserInfo = async () => {
        const { data: { status, result }} = await getCurrentUserMenuTree();
        if (status === 0) {
            localStorage.setItem('userInfo', JSON.stringify(result));
        }
    };

    useEffect(() => {
        if (location.href.indexOf('player?') == -1 || location.href.includes('moredata')){//不校验登录的页面，不进行和用户信息相关的操作() => window.open(`https://gtrs.gaodun.com/moredata?id=${vigoUserId}`)
            gerUserInfo();
            setUserConfg();
            sensorsInit();
        }
        $reqAppEntryModuleData();
        return () => {
            if (REFRESH_TIMER.current) {
                clearInterval(REFRESH_TIMER.current);
            }
            if (wmRef.current) {
                wmRef.current.destory();
                wmRef.current = null;
            }
        };
    }, []);

    return (
        <>
            <Provider store={props.store}>
                {
                    showModal?(
                        <UserInfoOutDate
                            appId={180302}
                            showModal={showModal}
                            onToLogin={() => toLogin()}
                            onUpdateInfo={() => updateInnfo()} />
                    ):(
                        <>
                            {
                                props.callWarningInfo && props.callWarningInfo.type === EnumCallInitStatus.connectFail && (
                                    <Alert
                                        showIcon
                                        closable
                                        className="alert-gtrs"
                                        message={props.callWarningInfo.message}
                                        type="error"
                                        onClose={() => {
                                            props.setWarningMessage({type:'', message:''});
                                        }} />
                                )
                            }
                            <BrowserRouter basename={window.__POWERED_BY_QIANKUN__ ? '/system/gtrs' : '/'}>
                                {
                                    appEntryError ? (
                                        <Switch>
                                            <Route
                                                path="/error"
                                                render={p => {
                                                    return <Error path={path.current} />;
                                                }} />
                                            <Route path="*">
                                                <Redirect to="/error" />
                                            </Route>
                                        </Switch>
                                    ) : appEntry ? (
                                        <userContext.Provider value={userRole}>
                                            <RootRoute userRole={userRole} />
                                        </userContext.Provider>
                                    ) : (
                                        <Spin
                                            size="large"
                                            tip="页面加载中..."
                                            className="app-spin" />
                                    )
                                }
                            </BrowserRouter>
                        </>
                    )
                }

            </Provider>
        </>
    );
};
export default process.env.NODE_ENV === 'development' ? hot(connect(mapStateToProps,mapDispatchToProps)(App)) : connect(mapStateToProps,mapDispatchToProps)(App);
